export const ENV_CONFIG = (() => {
  const hostname = window.location.hostname.toLowerCase();
  
  let apiBaseUrl = "";
  let appBaseUrl = "";
  let logoutBaseUrl = "";

  if (hostname.includes("localhost")) {
    apiBaseUrl = "https://shadowiq-dev.connexia.championx.com/api";
    appBaseUrl = "localhost:3000";
    logoutBaseUrl = process.env.REACT_APP_LOGOUT_BASE || ""; 
  } else if (hostname.includes("shadowiq-dev")) {
    apiBaseUrl = "https://shadowiq-dev.connexia.championx.com/api";
    appBaseUrl = "shadowiq-dev.connexia.championx.com";
    logoutBaseUrl = process.env.REACT_APP_LOGOUT_BASE || ""; // dev logout
  } else if (hostname.includes("shadowiq-qa")) {
    apiBaseUrl = "https://shadowiq-qa.connexia.championx.com/api";
    appBaseUrl = "shadowiq-qa.connexia.championx.com";
    logoutBaseUrl = process.env.REACT_APP_LOGOUT_BASE || ""; // qa logout 
  } else if (hostname.includes("shadowiq.connexia.championx.com")) {
    apiBaseUrl = "https://shadowiq.connexia.championx.com/api";
    appBaseUrl = "shadowiq.connexia.championx.com"; 
    logoutBaseUrl = process.env.REACT_APP_LOGOUT_BASE_PROD || ""; // prod logout
  } else {
    apiBaseUrl = "https://shadowiq-dev.connexia.championx.com/api";
    appBaseUrl = "shadowiq-dev.connexia.championx.com";
    logoutBaseUrl = process.env.REACT_APP_LOGOUT_BASE || ""; // dev logout
  }

  return {
    apiBaseUrl,
    logoutUrl: `${logoutBaseUrl}${appBaseUrl}`,
    amChartsLicense: process.env.REACT_APP_AM_CHARTS_LICENSE,
  };
})();